var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcArrowRightFill = function SvgIcArrowRightFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 12.001a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 0-5h-15a2.5 2.5 0 0 0-2.5 2.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.679 4.212a2.5 2.5 0 0 0 .007 3.536l4.271 4.253-4.27 4.253a2.5 2.5 0 1 0 3.527 3.543l6.05-6.024a2.5 2.5 0 0 0 0-3.543l-6.05-6.025a2.5 2.5 0 0 0-3.535.007",
    clipRule: "evenodd"
  })));
};
export default SvgIcArrowRightFill;